import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-fsce',
    templateUrl: './page-fsce.component.html',
    styleUrls: ['./page-fsce.component.css'],
    standalone: false
})
export class PageFsceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
